import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useThirdAnalyses from 'hooks/useThirdAnalyses';
import { thirdAnalysesSelectors } from "features/thirdAnalyses";

const ThirdAnalysesList = () => {
  const { getThirdAnalyses } = useThirdAnalyses();
  const { data, pagination } = useCustomSelector(thirdAnalysesSelectors.getThirdAnalysesData);
  const fetching = useCustomSelector(thirdAnalysesSelectors.thirdAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getThirdAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ThirdAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);